var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"a-keyboard-key keyboard-key",attrs:{"type":"button","aria-label":("" + _vm.ariaLabel + _vm.item)},on:{"click":function($event){return _vm.onClick(_vm.item)}}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.item)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }